import React, { Component } from 'react';

/**
 * Higher Order Component to insert class name: react-component
 * this will be used by semantic dropdowns to differentiate it
 * from other components.
 */

export default function withDefaultClassName(WrappedComponent) {
  class WithDefaultClassName extends Component {
    render() {
      const { className, ...passThroughProps } = this.props;

      return (
        <WrappedComponent
          className={`react-component ${className || ''}`}
          {...passThroughProps}
        />
      );
    }
  }
  WithDefaultClassName.displayName = 'WithDefaultClassName';
  return WithDefaultClassName;
}
